import { render, staticRenderFns } from "./EditTerm.vue?vue&type=template&id=5f9f9588"
import script from "./EditTerm.vue?vue&type=script&lang=js"
export * from "./EditTerm.vue?vue&type=script&lang=js"
import style0 from "./EditTerm.vue?vue&type=style&index=0&id=5f9f9588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports